import { SVGProps, useId } from 'react';

import { unitMapping } from 'lib/style';

type Props = { className?: string; size?: keyof typeof unitMapping } & Pick<
  SVGProps<SVGPathElement>,
  'fill'
>;

export const Shape = ({ className, fill, size = 4 }: Props) => {
  const id = useId();
  return (
    <svg
      className={className}
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      viewBox="0 0 30 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1132 0.753381C13.8996 -0.251127 16.1004 -0.251127 17.8868 0.753381L27.1133 5.94173C28.8996 6.94623 30 8.80264 30 10.8117V21.1883C30 23.1974 28.8996 25.0538 27.1133 26.0583L17.8868 31.2466C16.1004 32.2511 13.8996 32.2511 12.1132 31.2466L2.88675 26.0583C1.10042 25.0538 0 23.1974 0 21.1883V10.8117C0 8.80264 1.10042 6.94623 2.88675 5.94173L12.1132 0.753381Z"
        fill={fill || `url(#${id})`}
      />
      {!fill && (
        <defs>
          <linearGradient
            id={id}
            x1="23.8995"
            y1="27.3137"
            x2="1.47232"
            y2="7.68993"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#5974FF" />
            <stop offset="1" stopColor="#2943CC" />
          </linearGradient>
        </defs>
      )}
    </svg>
  );
};
